/*!
 * Copyright (c) 2019. GLiNTECH Pty Ltd.
 */
$(document).on("click", ".toggle-navigation", function (e) {
    e.preventDefault();
    var $navigation = $(".navigation-sidebar");
    $navigation.toggleClass("hidden-sm hidden-xs");
    var $show = $('.show-navigation');
    $show.toggleClass("hidden-xs hidden-sm", !$navigation.hasClass("hidden-xs"));
});

$(document).on("click", ".page-tree button.twixie", function (e) {
    var $target = $(e.target);
    $target.parent(".is-parent").toggleClass("selected");
});

(function () {
    var selector = ".wiki-content .confluence-embedded-file-wrapper .confluence-embedded-image[height]";
    $(selector).on("load", function (e) {
        resizeImage(e.target);
    });

    $(function () {
        $(selector).each(function (i, img) {
            resizeImage(img);
        });
    });

    function resizeImage(img) {
        var $img = $(img);
        var $parent = $(".wiki-content");
        var width = $img.width();
        if (width > $parent.width()) {
            $img.css({
                "width": "100%",
                "height": "auto"
            })
        }
    }
})();

$(function () {
    var $nav = $('.expanding-nav');
    var $vlinks = $('.expanding-nav > ul');
    var $button = $("#menu-x");

    function updateNav() {
        $nav.toggleClass("overflow", $vlinks.height() > 40)
    }

    var resizeTimeout;
    $(window).resize(function () {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }

        resizeTimeout = setTimeout(updateNav, 50);
    });

    $button.on('change', function (e) {
        $nav.toggleClass('open', e.target.checked);
    });

    updateNav();
});

$(function () {
    function dummyElement(precedenceLevel) {
        var $element = $({});
        $element.data('precedenceLevel', precedenceLevel);
        return $element;
    }

    function getPrecedenceLevel(element) {
        return $(element).data('precedenceLevel');
    }

    function setPrecedenceLevel(element, precedenceLevel) {
        $(element).data('precedenceLevel', precedenceLevel);
        return element;
    }

    function hasPrecedenceLevel(element, precedenceLevel) {
        return precedenceLevel === getPrecedenceLevel(element);
    }

    /**
     * Builds a table of contents based on the supplied list of elements.
     * @param elementsArray The HTML elements to derive the TOC from. Each element is expected to have been pre-populated
     * with a tocLevel data attribute which indicates its relative position in the TOC hierarchy.
     * @param elementFactory Used to instantiate the various HTML elements used to build the TOC
     * @param parentOutline The outline inherited from the parent TOC level
     */
    function buildTocTree(elementsArray, elementFactory, parentOutline) {
        if (elementsArray.length === 0) {
            return $();
        }

        var highestElementPrecedence = elementsArray
            .map(getPrecedenceLevel)
            .reduce(function (a, b) {
                return Math.min(a, b);
            });

        // Make sure the first element in the list matches the highest precedence level.
        // If it doesn't, then prepend the list with a synthetic blank element that does.
        // With properly-structured document headers this shouldn't be necessary, but we need to guard against wacky data.
        if (!hasPrecedenceLevel(elementsArray[0], highestElementPrecedence)) {
            elementsArray.unshift(dummyElement(highestElementPrecedence));
        }

        var currentList = elementFactory.createTocLevelContainer();

        // This buffers up "sub-headers" of the current TOC level until they need to be written out as a sub-toc
        var subListBuffer = {
            subElements: [],
            currentItem: undefined,
            outline: undefined,

            flush: function () {
                if (this.subElements.length > 0 && this.currentItem) {
                    buildTocTree(this.subElements, elementFactory, this.outline).appendTo(this.currentItem);
                    this.subElements = [];
                }
            },

            add: function (element) {
                this.subElements.push(element);
            },

            resetItem: function (currentOutlineItem) {
                this.outline = (parentOutline || []).slice(0);
                this.outline.push(currentOutlineItem);

                this.currentItem = elementFactory.createTocItemContainer();
                this.currentItem.appendTo(currentList);
                return this.currentItem;
            }
        };

        var outlineCounter = 0;

        elementsArray.forEach(function (element) {
            if (hasPrecedenceLevel(element, highestElementPrecedence)) {
                outlineCounter++;
                subListBuffer.flush();
                subListBuffer.resetItem(outlineCounter);
                if (element.textContent) {
                    createTocItemBody(element, subListBuffer.outline.join('.'))
                        .appendTo(subListBuffer.currentItem);
                } else {
                    subListBuffer.currentItem.addClass('toc-empty-item');
                }
            } else {
                subListBuffer.add(element);
            }
        });
        subListBuffer.flush();

        if (parentOutline.length === 0 && elementFactory.decorateToc) {
            elementFactory.decorateToc(currentList);
        }

        return currentList;
    }

    function getItemBody(params) {
        return `<span class="toc-item-body" data-outline="${params.outline}"><span class="toc-outline">${params.outline}</span><a href="${params.linkHref}" class="toc-link">${params.linkText}</a></span>`;
    }

    /**
     * Creates an HTML element representing a single item in the TOC, including outline level and a link.
     */
    function createTocItemBody(element, outline) {
        return $(getItemBody({
            outline: outline,
            linkHref: '#' + element.id,
            linkText: element.textContent
        }));
    }

    function getFlatItemContainer() {
        return `<span class="toc-item-container"></span>`;
    }

    function getFlatStyleItemSeparator(separator) {
        return `<span class="toc-separator">${separator}</span>`;
    }

    /**
     * Creates HTML elements for use in building a flat-style TOC
     */
    function flatTocElementFactory(config) {
        return {
            createTocLevelContainer: function () {
                return this.createTocItemContainer();
            },
            createTocItemContainer: function () {
                return $(getFlatItemContainer());
            },
            decorateToc: function (tocElement) {
                function appendSeparator(configKey, defaultValue) {
                    var separator = configKey in config ? config[configKey] : defaultValue;
                    if (separator) {
                        var $separatorElement = $(getFlatStyleItemSeparator(separator));
                        $separatorElement.appendTo(tocElement);
                    }
                }

                // At this point the various to items are in nested spans, so to be tidy we want to flatten those out.
                // We pick each item out of the DOM tree and move it to the top level of the TOC node, decorating them
                // with pre/mid/post separators as we go
                appendSeparator('preseparator', '[ ');

                $(tocElement).find('span.toc-item-body').each(function (idx, element) {
                    if (idx > 0) appendSeparator('midseparator', ' ] [ ');
                    $(element).appendTo(tocElement);
                });

                appendSeparator('postseparator', ' ]');

                // Finally we remove all of the intermediate spans that are now empty
                $(tocElement).find('.toc-item-container').remove();
            }
        };
    }

    function listStyleTocLevelContainer(params) {
        return '<ul style="' + ((params.cssliststyle) ? ' list-style: ' + params.cssliststyle + ';' : '') + ((params.csslistindent) ? ' padding-left: ' + params.csslistindent + ';' : '') + '"></ul>';

    }

    /**
     * Creates HTML elements for use in building a list-style TOC
     */
    function listTocElementFactory(config) {
        return {
            createTocLevelContainer: function () {
                return $(listStyleTocLevelContainer({
                    cssliststyle: config['cssliststyle'],
                    csslistindent: config['csslistindent']
                }));
            },
            createTocItemContainer: function () {
                return $("<li></li>");
            }
        };
    }

    function headerRegexFilter(config) {
        var includeRegex;
        if (config['includeheaderregex']) includeRegex = new RegExp(config['includeheaderregex']);
        var excludeRegex;
        if (config['excludeheaderregex']) excludeRegex = new RegExp(config['excludeheaderregex']);

        return function () {
            var headerText = $(this).text();
            if (includeRegex && !includeRegex.test(headerText)) {
                return false;
            }

            return !(excludeRegex && excludeRegex.test(headerText));
        }
    }

    /**
     * Builds a table of contents based on the current page content's header elements.
     */
    function buildTocTreeFromHeaders(elementFactory, config) {
        var headerElementsSelector = config['headerelements'];
        var elementPrecedence = headerElementsSelector.split(',');
        var regexFilter = headerRegexFilter(config);

        var headerElements = $("#main-content")
            .find(headerElementsSelector)
            .filter(regexFilter)
            .each(function () {
                setPrecedenceLevel(this, elementPrecedence.indexOf(this.nodeName))
            })
            .toArray();

        return buildTocTree(headerElements, elementFactory, []);
    }

    $(".client-side-toc-macro").each(function () {
        var $tocContainer = $(this);
        var config = $tocContainer.data() || {};

        var elementFactory;
        if (config['structure'] === 'flat') {
            elementFactory = flatTocElementFactory(config);
        } else {
            elementFactory = listTocElementFactory(config);
        }

        if (config['numberedoutline'] !== true) {
            $tocContainer.addClass('hidden-outline');
        }

        $tocContainer.html(buildTocTreeFromHeaders(elementFactory, config));
    });

    //expand macro
    $(".expand-control-text, .expand-control-icon").on("click", function (e) {
        var expand = $(e.target).parent().next();
        if (!expand.hasClass("expand-hidden")) {
            expand.addClass("expand-hidden")
        } else {
            expand.removeClass("expand-hidden")
        }
        if ($(e.target).parent().children(".expand-control-icon").hasClass("expanded")) {
            $(e.target).parent().children(".expand-control-icon").removeClass("expanded")
        } else {
            $(e.target).parent().children(".expand-control-icon").addClass("expanded")
        }
        return false;
    })

    function getIndexPosition(text, search, n = {}) {
        let indexOf = 0;
        let latestIndexOf = -1;
        let count = 1;
        while (indexOf != -1) {
            indexOf = text.indexOf(search, indexOf + 1);
            if (indexOf != -1) latestIndexOf = indexOf;
            if (count == n) {
                break;
            }
            count++;
        }
        return latestIndexOf;
    }

    function htmlDecode(input) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
      }

    //recently updated pages macro
    $.getJSON("/search/index.json", resp => {
        let values = resp.values;
        let foundIndex = [];
        values = Object.entries(values);
        values = values.filter(value => {
            if (!value[1].title)
                return null;
            return value;
        });
        let sort = values.sort((a, b) => {
            let date1 = new Date();
            let date2 = new Date();
            let when1;
            let when2;
            if (a[1].version) {
                when1 = a[1].version.when;
            }
            if (b[1].version) {
                when2 = b[1].version.when;
            }
            if (a[1].history) {
                when1 = a[1].history.lastUpdated.when;
            }
            if (b[1].history) {
                when2 = b[1].history.lastUpdated.when;
            }
            if (when1)
                date1 = new Date(when1)
            if (when2)
                date2 = new Date(when2)
            return (date1 < date2) ? 1 : -1;
        })
        $(".more-link").on("click", (e) => {
            e.preventDefault();
            let found = $(".results-container > ul > li .update-item-content > a");
            let j = 0;
            for (let i = 0; sort.length > i; i++) {
                let value = sort[i][1];
                let foundValue = found.toArray().find(elm => {
                    return elm.textContent == htmlDecode(value.title)
                });
                if (foundValue) {
                    foundIndex.push(i);
                } else {
                    j++;
                    if (!value.type) {
                        value.type = "page"
                    }
                    let iconType = "";
                    switch (value.type) {
                        case "attachment": iconType = "attachment-unknown"; break;
                        case "image": iconType = "attachment-image"; break;
                        default: iconType = value.type; break;
                    }
                    let lastUpdated = "";
                    if (value.version)
                        lastUpdated = value.version.friendlyWhen;
                    if (value.history)
                        lastUpdated = value.history.lastUpdated.friendlyWhen;
                    $(".results-container > ul").append(`
    <li class="update-item"><div class="update-item-icon">
                <span class="icon content-type-${iconType}"> </span>
            </div>
    <div class="update-item-content">
                                    <a href="${value.encodedPath}" title="">${value.title}</a>
    
                    <div class="update-item-meta">
                        ${lastUpdated} </div>
                </div></li>`)
                    let startIndexSubStr = $("a.more-link").attr("href").substr(getIndexPosition($("a.more-link").attr("href"), "startIndex"), $("a.more-link").attr("href").length)
                    let startIndex = getIndexPosition(startIndexSubStr, "=", 1);
                    if (j > parseInt(startIndex))
                        break;
                }
            }
            for (let k = 0; foundIndex.length > k; k++) {
                sort.splice(foundIndex[k], 1);
            }
            foundIndex = [];

            if (sort.length === 0)
                $(".more-link-container").addClass("hidden")
        })
    });
    //code block macro styling
    var version = '3.0.83';
    $('head').append(`
        <style>          
            .copybtn {
                visibility: hidden;
                text-decoration: none;
                border: none;
                padding: 12px 40px;
                background-color: #bababa;
                top: 0;
                right: 20px;
                border-radius: 3px;
                outline: none;
                position: absolute;
                padding: 1px 3px;
                transition: 0.1s all;
            }    
            .copybtn:active {
                transform: scale(0.92);
            }
            .tooltip .tooltiptext {
                visibility: hidden;
                background-color: #5c5c5c;
                color: #fff;
                text-align: center;
                border-radius: 3px;
                padding: 1px 3px;
                position: absolute;
                z-index: 1;
                bottom: 150%;
                font-size: 10px;
                left: -30%;
              }          
              .tooltip:hover .tooltiptext {
                visibility: visible;
              }
              .copycontainer:hover .copybtn {
                visibility: visible;
              }
        </style> 
    `)
    $('head').append('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/styles/shCore.min.css" />')
    $('.syntaxhighlighter-pre').each(function () {
        var classes = $(this).attr('data-syntaxhighlighter-params');
        var classesArray = classes.split(';');
        var theme = 'Default';
        for (var i = 0; i < classesArray.length; i++) {
            if (classesArray[i].indexOf('theme:') != 0) {
                theme = classesArray[i].trim()
                theme = theme.substring(theme.indexOf(' ') + 1, theme.length);
                if (theme == 'DJango') {
                    theme = theme.charAt(0) + theme.charAt(1).toLowerCase()
                        + theme.substring(2, theme.length)
                }
                if (theme == 'Confluence' || theme == 'true') {
                    theme = 'Default';
                }
            }
        }
        
        $('head').append('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />')
        
        var button = $('<button>')
            .append('<div class="tooltip"><span class="tooltiptext">Copy</span><i class="fa fa-copy" style="font-size:12px"></i></div>')
            .addClass("copybtn");

        $(this.parentElement).css("position", "relative").addClass("copycontainer")
        $(this.parentElement).append(button).on("click", () => {
            var $temp = $("<textarea>");
            $("body").append($temp);
            $temp.val(this.innerText).trigger("select");
            document.execCommand("copy");
            $temp.remove();
        })

        $('head').append('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/styles/shTheme' + theme + '.min.css" />');
        $('.syntaxhighlighter-pre').addClass(classes)
        $('.syntaxhighlighter-pre').addClass('syntaxhighlighter')

    })
    

    $.getScript('https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shCore.js', function () {
        $.getScript('https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shAutoloader.min.js', function () {
            SyntaxHighlighter.autoloader(
                ['as3', 'actionscript3', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushAS3.min.js'],
                ['applescript', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushAppleScript.min.js'],
                ['bash', 'shell', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushBash.min.js'],
                ['cf', 'coldfusion', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushColdFusion.min.js'],
                ['c-sharp', 'csharp', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushCSharp.min.js'],
                ['cpp', 'c', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushCpp.min.js'],
                ['css', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushCss.min.js'],
                ['delphi', 'pas', 'pascal', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushDelphi.min.js'],
                ['diff', 'patch', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushDiff.min.js'],
                ['erl', 'erlang', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushErlang.min.js'],
                ['groovy', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushGroovy.min.js'],
                ['js', 'jscript', 'javascript', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushJScript.min.js'],
                ['java', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushJava.min.js'],
                ['jfx', 'javafx', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushJavaFX.min.js'],
                ['perl', 'pl', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushPerl.min.js'],
                ['php', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushPhp.min.js'],
                ['plain', 'text', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushPlain.min.js'],
                ['ps', 'powershell', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushPowerShell.min.js'],
                ['py', 'python', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushPython.min.js'],
                ['rails', 'ror', 'ruby', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushRuby.min.js'],
                ['sass', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushSass.min.js'],
                ['scala', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushScala.min.js'],
                ['vb, vbnet', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushVb.min.js'],
                ['xml', 'xhtml', 'xslt', 'html', 'xhtml', 'https://cdnjs.cloudflare.com/ajax/libs/SyntaxHighlighter/' + version + '/scripts/shBrushXml.min.js']
            )
            SyntaxHighlighter.all()
        })
    })
});
$(function (){
    
    if($('img').length > 0){

        $('head').append(`<style>
            .modal {
                display: none;
                position: fixed;
                z-index: 1;
                white-space: nowrap;  
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                overflow: auto;
                text-align: center;
                background-color: rgb(0,0,0);
                background-color: rgba(0,0,0,0.9);
            }
            
            .modal-content{  
                vertical-align: middle;        
            }
            .alignCenterhelper{
                display: inline-block;
                height: 100%;
                vertical-align: middle;
            }
            .modal-content{  
                -webkit-animation-name: zoom;
                -webkit-animation-duration: 0.6s;
                animation-name: zoom;
                animation-duration: 0.6s;
            }

            @-webkit-keyframes zoom {
                from {-webkit-transform:scale(0)} 
                to {-webkit-transform:scale(1)}
            }

            @keyframes zoom {
                from {transform:scale(0)} 
                to {transform:scale(1)}
            }

            /* The Close Button */
            .close {
                position: absolute;
                right: 1em;
                top: 0.5em;
                background-color: rgb(100,100,100);
                border-radius: 0.1em;
                color: #f1f1f1;
                transition: 0.3s;
                padding-right: 0.2em;
                padding-left: 0.2em;
                padding-top: 0.2em;
                padding-bottom: 0.3em;
            }
            .navForModalIW {
                position: -webkit-sticky;
                position: sticky;
                z-index: 1; 
                font-weight: bold;
                top: 0;
                font-size: 2.5em;
                color: #f1f1f1;
                padding-top: 1em;
                padding-bottom: 1em;
                background-color: rgb(50,50,50);
                background-color: rgb(50,50,50, 0.9);
                align-text: center;
            }
            .zoomIconPlus{
                right: 46%;
            }
            .zoomIconMinus{
                left: 46%;
            }
            .zoomIcons{
                position: absolute;   
                top: 0.5em;          
                border-radius: 0.1em;
                background-color: rgb(100,100,100);
                padding-right: 0.2em;
                padding-left: 0.2em;
                padding-top: 0.2em;
                padding-bottom: 0.3em;
            }

            .zoomIcons:hover,
            .zoomIcons:focus {
                color: #bbb;
                text-decoration: none;
                cursor: pointer;
            }

            .close:hover,
            .close:focus {
                color: #bbb;
                text-decoration: none;
                cursor: pointer;
            }
            @media only screen and (max-width: 700px){
                .zoomIconPlus{
                    right: 37%;
                }
                .zoomIconMinus{
                    left: 37%;
                }
                .imageModalContainerIW {
                    touch-action: pan-x pinch-zoom;
                }
                .modal-content {
                    width: 100%;       
                }
            }
            
        </style>`)

        $('body').append(
            `<div id="imageModalContainerIW" class="modal">
                <div class="navForModalIW">
                    <span class="zoomIconPlus zoomIcons" id="modalSpanZoomIW">+</span>
                    <span class="zoomIconMinus zoomIcons" id="modalSpanZoomOutIW">-</span>
                    <span class="close" id="modalSpanCloseIW">x</span>
                </div>
                <span class="alignCenterhelper"></span>
                <img class="modal-content" id="imgInModalIW">
            </div>
            `)
        var scale = 1.0;
        $("#modalSpanCloseIW").on("click", function(){
            scale = 1.0;
            $("#imgInModalIW").css("transform", `scale(${scale})`)
            $("#imageModalContainerIW").css("display", "none");
        });
        $("#modalSpanZoomIW").on("click", function(){
            scale += 0.15;
            $("#imgInModalIW").css("transform", `scale(${scale})`)
        });
        $("#modalSpanZoomOutIW").on("click", function(){
            scale -= 0.15;
            $("#imgInModalIW").css("transform", `scale(${scale})`)
            
        });

        $('img').each(function (){
            if(this.id === "imgInModalIW") return;     
            $(this).on("click", function(){
                $("#imgInModalIW").attr("src", $(this).attr('src'))
                $("#imageModalContainerIW").css("display", "block");
                
            })
            
        })
    }
    
})